// src/store/slices/onboardingSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { onboarding } from "../../types";

// Initial state for the auth slice
const initialState: onboarding.OnboardingStateType = {
  sendOtp: {
    data: null,
    isLoading: false,
    error: null,
  },
  verifyOtp: {
    data: null,
    isLoading: false,
    error: null,
  },
};

// Define the onboarding slice
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    // send otp
    sendOtpRequest: (
      state: onboarding.OnboardingStateType,
      action: PayloadAction<any>
    ) => {
      state.sendOtp.isLoading = true;
      state.sendOtp.data = null;
      state.sendOtp.error = null;
    },
    sendOtpSuccess: (
      state: onboarding.OnboardingStateType,
      action: PayloadAction<any>
    ) => {
      state.sendOtp.isLoading = false;
      state.sendOtp.data = action.payload;
      state.sendOtp.error = null;
    },
    sendOtpError: (
      state: onboarding.OnboardingStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.sendOtp.isLoading = false;
      state.sendOtp.data = null;
      state.sendOtp.error = error;
    },
    resetSendOtp: (
      state: onboarding.OnboardingStateType,
      action: PayloadAction<any>
    ) => {
      state.sendOtp.isLoading = false;
      state.sendOtp.data = null;
      state.sendOtp.error = null;
    },

    // verify otp
    verifyOtpRequest: (
      state: onboarding.OnboardingStateType,
      action: PayloadAction<any>
    ) => {
      state.verifyOtp.isLoading = true;
      state.verifyOtp.data = null;
      state.verifyOtp.error = null;
    },
    verifyOtpSuccess: (
      state: onboarding.OnboardingStateType,
      action: PayloadAction<any>
    ) => {
      state.verifyOtp.isLoading = false;
      state.verifyOtp.data = action.payload;
      state.verifyOtp.error = null;
    },
    verifyOtpError: (
      state: onboarding.OnboardingStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.verifyOtp.isLoading = false;
      state.verifyOtp.data = null;
      state.verifyOtp.error = error;
    },
  },
});

// Export actions and reducer
export const {
  // send otp
  sendOtpRequest,
  sendOtpSuccess,
  sendOtpError,
  resetSendOtp,

  // verify otp
  verifyOtpRequest,
  verifyOtpSuccess,
  verifyOtpError,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
